const rawBase =
  (typeof import.meta !== "undefined" && import.meta.env?.VITE_API_URL) ||
  process.env.REACT_APP_API_URL ||
  process.env.VITE_API_URL ||
  "";

function apiRoot() {
  return rawBase ? rawBase.replace(/\/+$/, "").replace(/\/api$/i, "") : "";
}

export async function fetchNotificationBadges() {
  const root = apiRoot();
  const token = typeof localStorage !== "undefined" ? localStorage.getItem("token") : "";
  if (!root || !token) return { documents: 0, rdv: 0 };
  const res = await fetch(`${root}/api/notifications/badges/summary`, {
    headers: { Authorization: `Bearer ${token}` },
    credentials: "include",
  });
  if (!res.ok) return { documents: 0, rdv: 0 };
  const d = await res.json().catch(() => ({}));
  return {
    documents: Number(d.documents) || 0,
    rdv: Number(d.rdv) || 0,
  };
}

export function markNotificationScopeRead(scope) {
  const root = apiRoot();
  const token = typeof localStorage !== "undefined" ? localStorage.getItem("token") : "";
  if (!root || !token) return Promise.resolve();
  return fetch(`${root}/api/notifications/badges/mark-read`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    credentials: "include",
    body: JSON.stringify({ scope }),
  }).then(() => {
    window.dispatchEvent(new CustomEvent("pms:badges:refresh"));
  });
}

export async function fetchUpcomingReminders() {
  const root = apiRoot();
  const token = typeof localStorage !== "undefined" ? localStorage.getItem("token") : "";
  if (!root || !token) return [];
  const res = await fetch(`${root}/api/notifications/reminders/upcoming`, {
    headers: { Authorization: `Bearer ${token}` },
    credentials: "include",
  });
  if (!res.ok) return [];
  const d = await res.json().catch(() => ({}));
  return Array.isArray(d.rdvs) ? d.rdvs : [];
}
